import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formikValidation, formikinitialvalues, replaceUnderscore } from "../../../../../../CommonFunction/common";

import { FormInputSectionComponent } from "../../../../FormInputSectionComponent/FormInputSectionComponent";
const AddPendingPODsSection = ({ inputfields, Type, fielddata, TypeOfPortal }) => {
  const [alldata, setalldata] = useState({});

  // useEffect(() => {

  //   if (fielddata) {
  //     fielddata.Collected_Date = GetTodaysDateINdmy()
  //     fielddata.Collected_By = getUserName()
  //   }
  // }, [fielddata]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alldata]);

  const validate = (values) => {
    setalldata(values);
  };

  useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: formikValidation(inputfields),
    validate,
    onSubmit: (values) => {
      // postlogin(values);
    },
  });
  // useEffect(()=>{
  // formik.setFieldValue("collected_date",GetTodaysDateINdmy())
  // formik.setFieldValue("collected_by",getUserName())

  // },[fielddata])
  return (
    <div className="FormSectionParent">
      {/* <form onSubmit={formik.handleSubmit} autoComplete="off">
        <FormInputSection
                      handelformikdata=""
          alldata={alldata}
          fields={fields}
          fielddata={fielddata}
          formikhandleInputChange={formik.handleChange}
          errors={formik.errors}
          touched={formik.touched}
          handleBlur={formik.handleBlur}
          TypeOfPortal={TypeOfPortal}
        />
      </form> */}
      <>
        <div className="sectionHeadings">{replaceUnderscore(Type)}</div>
        <div className="FormSection">
          <FormInputSectionComponent fielddata={fielddata} inputfields={inputfields} Type={Type} />
        </div>
      </>
    </div>
  );
};

export default AddPendingPODsSection;
